import { UserGroupShareRightCollection } from "sharebase/domain/userGroup";

export class UserGroupShareRightCollectionFactory {
    public static $inject = [
        'gettextCatalog'
    ];

    constructor(
        private readonly gettextCatalog: ng.gettext.gettextCatalog) {}

    public create(allowBits:number, denyBits:number) {
        return new UserGroupShareRightCollection(allowBits, denyBits, this.gettextCatalog)
    }
}


// WEBPACK FOOTER //
// ./src/sharebase/factories/userGroupShareRightCollectionFactory.ts